import { Link } from 'react-router-dom';
import { CONTACT_EMAIL } from '../config';
import '../CSS/navBar.css';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  };

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link className="brand footer-logo-link" to="/" onClick={scrollToTop}>
            <svg
              className="brand-logo"
              viewBox="0 0 64 48"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M8 10H42V36H25" />
              <path d="M42 18H52C55.6 18 59 21.4 59 25V36H55" />
              <path d="M42 27H56C60.4 27 62 30.2 62 34V36H55" />
              <path d="M8 36H13" />
              <path d="M25 36H43" />
              <path d="M14 16H25" />
              <path d="M10 22H25" />
              <path d="M5 28H23" />
              <path d="M10 34H23" />
              <circle cx="19" cy="36" r="6" />
              <circle cx="49" cy="36" r="6" />
              <path d="M47 30H51" />
            </svg>
            Emmapro Logistix
          </Link>
          <p>
            Dispatch proposal support for owner operators, carriers, dedicated
            lanes, and over-the-road freight.
          </p>
        </div>

        <nav className="footer-links" aria-label="Footer navigation">
          <Link to="/" onClick={scrollToTop}>
            Service
          </Link>
          <Link to="/services/owner-operator">Owner operator</Link>
          <Link to="/services/small-fleet-carrier-dispatch-support">
            Carrier dispatch support
          </Link>
          <Link to="/services/dedicated-lanes-routes">Dedicated lanes</Link>
          <Link to="/services/over-the-road">Over-the-Road</Link>
        </nav>

        <div className="footer-contact">
          <p>Ready to talk freight?</p>
          <a className="footer-email" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          <Link className="footer-action" to="/contact" onClick={scrollToTop}>
            Contact us
          </Link>
        </div>
      </div>
      <div className="footer-bottom">
        <span>&copy; Emmapro Logistix. All rights reserved.</span>
        <span>Dispatch support built around clear communication.</span>
      </div>
    </footer>
  );
}

export default Footer;
